export default __webpack_public_path__ + "static/media/spriral-guard-help-image.61268331.jpg";